import type { TFunction } from 'i18next'

import type { TagColor } from '@/components/Tag/Tag'

import type { SchoolBreakStatus } from '../types'

export const schoolBreakStatusToTagMap = (
  tc: TFunction<'schoolSettings'>
): Record<SchoolBreakStatus, { label: string; color: TagColor }> => ({
  active: {
    color: 'green',
    label: tc('label.active')
  },
  future: {
    color: 'blue',
    label: tc('label.future')
  },
  past: {
    color: 'gray',
    label: tc('label.past')
  }
})
